
import axios from 'axios';
import { Client } from 'client-sdk/src';
import handleError from '../../../utils/handleError';
import {UpdateEntranceStatusRequestBuilder} from "client-sdk/src/entrances/updateStatus";
// export default const getDrivers = () => {

// }

const token = localStorage.getItem('token');

export async function updateEntranceStatus(statusUpdateInfo: any) {
  try {
    const updateStatus = new UpdateEntranceStatusRequestBuilder()
    .data(statusUpdateInfo)
    .build();
    const client = new Client(token as string);
    const response = client.execute(
      updateStatus,
    );
    return response;
  } catch (error) {
    return handleError(error.response);
  }
}



export default updateEntranceStatus;


